import { render } from "./TrfDocumentoInput.vue?vue&type=template&id=2fdd5799&scoped=true"
import script from "./TrfDocumentoInput.vue?vue&type=script&lang=js"
export * from "./TrfDocumentoInput.vue?vue&type=script&lang=js"

import "./TrfDocumentoInput.vue?vue&type=style&index=0&id=2fdd5799&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdd5799"],['__file',"src/components/Input/TrfDocumentoInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fdd5799"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fdd5799', __exports__)) {
    console.log('reload')
    api.reload('2fdd5799', __exports__)
  }
  
  module.hot.accept("./TrfDocumentoInput.vue?vue&type=template&id=2fdd5799&scoped=true", () => {
    console.log('re-render')
    api.rerender('2fdd5799', render)
  })

}


export default __exports__